import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	errorLoadingCardsPreamble: {
		id: 'custom-sites-extensions.link-cards-content.card-components.error-states.loading-cards-error-preamble',
		defaultMessage: 'We’re having trouble loading these cards.',
		description:
			'Footer message shown when there was an error fetching search results for dynamic cards.',
	},
	errorLoadingCardsSupport: {
		id: 'custom-sites-extensions.link-cards-content.card-components.error-states.loading-cards-error-support',
		defaultMessage: 'Reload to try again.',
		description:
			'Footer message shown when there was an error fetching search results for dynamic cards.',
	},
});
